<template>
  <div class="invite-share">
    <div class="invite-share-title">{{title}}</div>
    <div class="invite-share-sub">{{subtitle}}</div>
    <button type="button" class="invite-native-btn" @click="nativeShare">
      Send
    </button>
    <button type="button" class="invite-copy-btn" @click="copyLink">
      {{copied ? 'Copied' : 'Copy link'}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'InviteShareButtons',
  props: {
    url: { type: String, required: true },
    itemLabel: { type: String, default: 'gift card' },
    merchantTitle: { type: String, default: '' }
  },
  data() {
    return { copied: false };
  },
  computed: {
    title: function() {
      return 'Send to a friend or family';
    },
    subtitle: function() {
      return 'Copy the link or share it. They do not need an email address first.';
    },
    shareText: function() {
      let name = this.merchantTitle ? this.merchantTitle : '';
      return 'I\'ve sent you a ' + this.itemLabel
          + (name ? ' for ' + name : '')
          + ': ' + this.url;
    }
  },
  methods: {
    copyLink: function() {
      let self = this;
      let done = function() {
        self.copied = true;
        setTimeout(function() { self.copied = false; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.url).then(done).catch(function() {
          self.fallbackCopy();
          done();
        });
        return;
      }
      this.fallbackCopy();
      done();
    },
    fallbackCopy: function() {
      let input = document.createElement('input');
      input.value = this.url;
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(input);
    },
    nativeShare: function() {
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        navigator.share({ title: this.itemLabel, text: this.shareText, url: this.url })
          .catch(function() {});
        return;
      }
      this.copyLink();
    }
  }
}
</script>

<style scoped>
.invite-share {
  text-align: left;
  padding: 8px 0 4px 0;
}
.invite-share-title {
  font-weight: 700;
  font-size: 16px;
  color: #031635;
}
.invite-share-sub {
  margin-top: 6px;
  font-size: 13px;
  color: #555;
  line-height: 1.4;
}
.invite-copy-btn,
.invite-native-btn {
  margin-top: 10px;
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 14px 16px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
}
.invite-native-btn {
  background: #031635;
  color: #fff;
}
.invite-copy-btn {
  background: #eee;
  color: #031635;
}
</style>



// WEBPACK FOOTER //
// src/components/InviteShareButtons.vue